export type ExperimentName = (typeof allExperimentNames)[number]

export type GateName =
  | 'pay_pal_partner'
  | 'pay_pal_partner_force_show'
  | 'pay_pal_vault_toggle_ns'
  | 'auto_cashouts'
  | 'pay_by_bank_method'
  | 'svea_method'
  | 'loan_mvp'
  | 'orders_page_new'
  | 'installment_first_rate_min_20_percent'
  | 'stm_payout_eligibility'
  | 'limited_subscription_absd'
  | 'admin_order_rates_page_v2'
  | 'order_order_rates_v2'
  | 'deprecated_summary_widget'
  | 'mangopay_bank_account_maintenance'
  | 'mondu_checkout_widget'
  | 'ps_prefinanced_vat'
  | 'close_crm_integration'
  | 'offline_event_cz_country'
  | 'meta_capi'
  | 'hide_withdrawal_link'
  | 'vat_payout_holdback'
  // SCL-1894: the payer picks the payment method at deal checkout. Per seller,
  // never a percentage rule — a percentage over browser sessions could offer one
  // payer a choice and the next payer on the same deal none (R5-AC3).
  | 'deal_checkout_payment_method_choice'
  | 'trial_cancellation'
  // SCL-2067 U1: the platform switch above the whole new e-tickets flow. Binary per
  // environment, never a percentage rule (see shop/utils/eticketsFlowGate.utils.ts).
  | 'etickets_personalisation'
  // MAC-2121 PLACEHOLDER: gate that redirects sign_up_new Step 3 to the agency page.
  | 'onboarding_funnel_agency_redirect'
  | 'ablefy_live'
  // SCL-2475: CCD II warns about, then blocks, installment plans on Sales OS deals.
  | 'warn_installments_for_ccd2_compliance'
  | 'disable_installments_for_ccd2_compliance'
  | ''
export type DynamicConfigName =
  | 'user_browser'
  | 'user_country'
  | 'payment_method_orchestrator_config'
  | 'recaptcha_config'
  | 'express_checkout_config'
  | 'change_attendee_recaptcha_config'
  | 'subscribe_recaptcha_config'
  | 'mangopay_bank_account_maintenance_date'
  | 'partner_apps_config'
  // MAC-2121: holds the `onboarding_funnel_agency_redirect` field — the agency page URL for the sign_up_new redirect.
  | 'campaign_redirect_url'
export type LayerName = ''

export const shopExperimentNames = [
  'shop__ab_first_rate_strategy_pricing_plan_selector',
  'shop__ab_express_checkout_paypal_combined_module',
  'shop__ab_merge_b2cb2b_payer_data_form',
] as const

export const payerExperimentNames = ['payer__ab_upsell_popular_label'] as const

export const appExperimentNames = ['app__sign_in_form_ab_test'] as const

export const cabinetExperimentNames = ['cabinet__ab_saas_plan_booking'] as const

export const allExperimentNames = [
  ...shopExperimentNames,
  ...payerExperimentNames,
  ...appExperimentNames,
  ...cabinetExperimentNames,
] as const
